import useLanguage from './useLanguage';

export default useLanguage;
